import React from "react"
import styles from "./ListEvents.module.css"
import {BaseButton} from "components"
import {PersonalCalendar} from "sections/calendar/parts"
import {PanelExpandedSection} from "uiKit/PanelExpandedSection"
import {Auth} from "types/auth"

type DisplayPart = "list" | "create"

type Props = {
    onNavigate?: (displayMode: DisplayPart) => void
    onClose?: () => void
    departmentId?: number
    student?: Auth.DepartmentStudent
    onSelectedDayChange?: (date: Date) => void
    selectedDay?: Date
}

export function ListEvents(props: Props) {
    const {onClose, onNavigate, student, onSelectedDayChange, selectedDay} = props

    return (
        <PanelExpandedSection title="Calendar" onClose={onClose}>
            <div className={styles.actionWrap}>
                <BaseButton
                    onClick={() => onNavigate("create")}
                    title="Add calendar event"
                    className={styles.addAction}
                />
            </div>
            <div className={styles.calendarWrap}>
                <PersonalCalendar
                    displayMode="panel"
                    departmentId={props.departmentId}
                    invitedUserId={student?.userId}
                    onSelectedDayChange={onSelectedDayChange}
                    selectedDay={selectedDay}
                />
            </div>
        </PanelExpandedSection>
    )
}
